import ConfirmChat from './ConfirmChatContainer';

export default ConfirmChat;
